import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableDataSetField } from '@/models/tableDataset/TableDataSetField';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { UserProfile } from '@/models/dexie/UserProfile';
import { UserProfileStore } from '@/store/store.userProfile';
import { ApiIdentifers } from '@/config/index';
import { ConfigurationService } from '@/services';

@Component
export default class TableHeaderItemComponent extends Vue {
    @PropSync('headerFields', { type: Array }) public syncedheaderFields!: TableDataSetField[];

    public userProfile?: UserProfile;

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.userProfile = this.getUserProfile;
    }

    get getUserProfile(): UserProfile {
        return UserProfileStore.userProfile;
    }

    get getUnitsConfiguration() {
        return ConfigurationService.unitsConfiguration;
    }

    @Watch('getUserProfile', { deep: true, immediate: false })
    public onGetIsLoggedInChanged(newValue: UserProfile) {
        // this.userProfile = newValue;
    }

    /**
     * Method that filters fields which should not be shown in the table view
     * filtered fields:
     *  - all unit format fields (the unit format is shown in the header)
     *  - general section unit format
     * @param fields
     * @returns
     */
    public getfilterUnitFormatFields(fields: TableDataSetField[]) {
        return fields.filter((f) => f.type !== FieldTypeEnum.UNIT && f.identifier !== ApiIdentifers.generalUnitFormat);
    }

    public getUnitFormat(field: TableDataSetField): string {
        let unitFormatName: string = '';

        if (field.type === FieldTypeEnum.NUMBER && field.unit !== undefined) {
            let unitFormatId: string = ApiIdentifers.unitTemperature; // handle temperature extra, format is selected by user profile
            if (field.unit !== ApiIdentifers.unitTemperature) {
                const unit = this.syncedheaderFields.find((x) => x.identifier === field.unit);
                if (unit !== undefined && unit.unitIdentifier !== undefined) {
                    unitFormatId = unit.unitIdentifier;
                } else {
                    unitFormatId = '';
                }
            }
            if (unitFormatId.length > 0) {
                const unitFormat = ConfigurationService.GetUnitsConfiguration.sections.find((sec) => sec.identifier === unitFormatId);
                if (unitFormat !== undefined && unitFormat.values !== undefined && this.userProfile !== undefined) {
                    const userProfileFormat = this.userProfile.units.find((upf) => upf.unitIdentifier === unitFormatId);
                    unitFormatName = userProfileFormat !== undefined && userProfileFormat.selectedValue !== undefined
                        ? (unitFormat.values.find((v) => v.value === userProfileFormat.selectedValue) || { text: '-' }).text
                        : (unitFormat.values.find((v) => v.value === unitFormat.base) || unitFormat.values[0]).text;
                }
            }
        } else if (field.type === FieldTypeEnum.NUMBER && field.fixedUnit !== undefined) {
            unitFormatName = field.fixedUnit;
        }

        return unitFormatName;
    }

    public getClasses(field: TableDataSetField): string {
        const classes: string[] = [];

        if (field.identifier === ApiIdentifers.notesInputText) {
            classes.push('medium');
        }

        return classes.join(' ');
    }
}
